// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2b0276d4","952":"020ead6b"}[chunkId] + ".chunk.js";
};